import React, { useState } from "react";
import { Link } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import { Button, Field, Input } from "@/components/design-system";
import { api, formatApiError } from "@/lib/api";
import { TID } from "@/lib/testIds";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) { setError(formatApiError(err)); }
    finally { setBusy(false); }
  };
  return (
    <AuthLayout
      eyebrow="Password reset"
      title="Forgot your password?"
      subtitle="We'll send you a secure link to choose a new one."
      footer={<>Remembered it? <Link to="/login" className="text-[#2D7FF9] font-semibold">Log in →</Link></>}
    >
      {sent ? (
        <div className="space-y-4">
          <p className="text-[#0B1F3A]/80">If an account exists for <b>{email}</b>, we've sent a reset link. Check your inbox and spam folder.</p>
          <Link to="/login"><Button variant="primary">Back to login</Button></Link>
        </div>
      ) : (
        <form onSubmit={onSubmit} className="space-y-5">
          <Field label="Email" htmlFor="forgot-email">
            <Input id="forgot-email" data-testid={TID.auth.forgotEmail} type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" />
          </Field>
          {error && <p className="text-sm font-medium text-red-600">{error}</p>}
          <Button data-testid={TID.auth.forgotSubmit} type="submit" variant="primary" className="w-full" disabled={busy}>{busy ? "Sending…" : "Send reset link"}</Button>
        </form>
      )}
    </AuthLayout>
  );
}
